import { TrackingEvent } from '@marketplace-web/shared/event-tracker-data'

type UserCmpActionEventArgs = {
  action: 'banner_accept_all' | 'banner_reject_all'
  isMobile?: boolean
}

export const userCmpActionEvent = (args: UserCmpActionEventArgs): TrackingEvent => {
  const { action, isMobile } = args

  return {
    event: 'user.cmp_action',
    extra: {
      action,
      isMobile,
    },
  }
}
